var map = {
	"./2019-2020.pdf": 72574,
	"./2020-2021.pdf": 10443,
	"./2021-2022.pdf": 57803,
	"./2022-2023.pdf": 45395,
	"./2023-2024.pdf": 73963,
	"./2024-2025.pdf": 93907
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74265;